import { signMessage } from '@wagmi/core';

import { config } from '~/config/wagmi';
import type { OriginName } from '~/interfaces/common';
import { fetchJson } from '~/utils/fetch-json';

import type { SignAliasMessageResponse } from './types';

export const signAliasMessage = async (
  originName: OriginName,
  alias: string,
) => {
  const res = await fetchJson<SignAliasMessageResponse>(
    `/origins/${originName}/attest?alias=${alias}`,
  );
  if (!res) {
    throw new Error('Failed signAliasMessage');
  }
  const sig = await signMessage(config, {
    message: res.value.message,
  });

  return {
    sig,
    originalChallengeParams: res.value,
  };
};
